import React from 'react';
import TicketReply from '../ReusedComponents/TicketReply'
import { useParams, useHistory } from 'react-router-dom'

export default function AdminTicket() {
    const history = useHistory();
    const { sid, uid } = useParams();

    // On a direct visit/refresh there is no navigation state, so guard it —
    // reading .userType off undefined was crashing the whole page.
    const navState = history.location.state || {};

    return (
        <div className="totalTicketingModule">

            <TicketReply
                userType={navState.userType || "admin"}
                title={navState.title || "Ticket Details"}
                options={[
                    { title: "Create Ticket", url: `/tickets/user/creating/${sid}/${uid}` },
                    { title: "Dashboard", url: `/tickets/admin/dashboard/${sid}/${uid}` },
                    { title: "Reports", url: `/tickets/admin/reports/${sid}/${uid}` }
                ]}
            />

        </div>
    )
}